module.exports = __webpack_public_path__ + "static/media/film-canister.4ef40855.svg";